import {makeGetAuthorizations} from 'main/factories/usecases/private/authorizations';
import {DateFormatEnum} from 'presentation/constants';
import {formatDateString} from 'presentation/utils';
import {AuthorizationStatusEnum} from 'domain/usecases';
import {FilteredAuthorizationsParams, Params} from './types';

export const getAuthorizationsList = async ({
	page,
	size,
	filterAuthorizationsByStatus,
	signal,
}: FilteredAuthorizationsParams) => {
	const params: Params = {
		page,
		size,
		signal,
	};

	const hasFilterAuthorizationsByStatus =
		filterAuthorizationsByStatus &&
		filterAuthorizationsByStatus.toUpperCase() !== AuthorizationStatusEnum.TODOS;

	if (hasFilterAuthorizationsByStatus) {
		params.situacoes = filterAuthorizationsByStatus.toUpperCase();
	}

	try {
		const response = await makeGetAuthorizations().get(params);

		const formattedAuthorizations = response.items?.map(authorization => ({
			...authorization,
			dsSituacao: authorization.dsSituacao?.replace(/_/g, ' ').toLocaleLowerCase(),
			dtAutorizacao: formatDateString(
				authorization.dtAutorizacao,
				DateFormatEnum.DATE_FORMAT_7,
				DateFormatEnum.DATE_FORMAT_8,
			),
			dtSolicitacao: formatDateString(
				authorization.dtSolicitacao,
				DateFormatEnum.DATE_FORMAT_7,
				DateFormatEnum.DATE_FORMAT_8,
			),
			dtValidade: formatDateString(
				authorization.dtValidade,
				DateFormatEnum.DATE_FORMAT_7,
				DateFormatEnum.DATE_FORMAT_8,
			),
		}));

		const responseFormatted = {
			...response,
			items: [...formattedAuthorizations],
		};

		return responseFormatted;
	} catch (error) {
		throw new Error();
	}
};
